import { ActionType, createAction, createAsyncAction } from "typesafe-actions";

import type LeaderboardItem from "@mapmycustomers/shared/types/entity/LeaderboardItem";
import { AnyEntity } from "@mapmycustomers/shared/types/entity/types";
import User from "@mapmycustomers/shared/types/User";

import StackRankDrillDownViewState from "@app/scene/dashboard/store/stackRank/DrillDownViewState";
import { DrillDownListFetcherPayload } from "@app/scene/dashboard/types/DrillDownListFetcher";
import DrillDownViewState from "@app/scene/dashboard/types/DrillDownViewState";
import PerformanceData from "@app/scene/dashboard/types/PerformanceData";

import StackRankViewState from "./StackRankViewState";

export const initializeStackRank = createAsyncAction(
  "@dashboard/stackRank/initialize/request",
  "@dashboard/stackRank/initialize/success",
  "@dashboard/stackRank/initialize/failure"
)<
  void,
  { drillDownViewState: StackRankDrillDownViewState; viewState?: StackRankViewState },
  void
>();

export const fetchMetrics = createAsyncAction(
  "@dashboard/stackRank/fetchMetrics/request",
  "@dashboard/stackRank/fetchMetrics/success",
  "@dashboard/stackRank/fetchMetrics/failure"
)<Partial<StackRankViewState>, PerformanceData, void>();

// basically, the same as fetchMetrics, but updates the viewState w/o fetching the data
export const updateStackRankViewState = createAction("@dashboard/stackRank/updateViewState")<
  Partial<StackRankViewState>
>();

export const showStackRankDrillDown = createAction("@dashboard/stackRank/showDrillDown")<void>();
export const hideStackRankDrillDown = createAction("@dashboard/stackRank/hideDrillDown")<void>();

export const fetchDrillDownData = createAsyncAction(
  "@dashboard/stackRank/fetchDrillDownData/request",
  "@dashboard/stackRank/fetchDrillDownData/success",
  "@dashboard/stackRank/fetchDrillDownData/failure"
)<
  Partial<{
    drillDownViewState: Partial<StackRankDrillDownViewState>;
    viewState: Partial<StackRankViewState>;
  }>,
  LeaderboardItem[],
  void
>();

export const updateDrillDownViewState = createAction(
  "@dashboard/stackRank/updateDrillDownViewState"
)<Partial<StackRankDrillDownViewState>>();

export const exportDrillDownData = createAction("@dashboard/stackRank/exportDrillDownData")<void>();

export const showUserDrillDown = createAsyncAction(
  "@dashboard/stackRank/showUserDrillDown/request",
  "@dashboard/stackRank/showUserDrillDown/success",
  "@dashboard/stackRank/showUserDrillDown/failure"
)<undefined | User["id"][], { viewState: DrillDownViewState }, void>();
export const hideUserDrillDown = createAction("@dashboard/stackRank/hideUserDrillDown")<void>();

export const fetchUserDrillDownData = createAsyncAction(
  "@dashboard/stackRank/fetchUserDrillDownData/request",
  "@dashboard/stackRank/fetchUserDrillDownData/success",
  "@dashboard/stackRank/fetchUserDrillDownData/failure"
)<
  DrillDownListFetcherPayload<AnyEntity>,
  {
    totalFilteredRecords: number;
    totalRecords: number;
  },
  unknown
>();

export const applyUserDrillDownListViewSettings = createAction(
  "@dashboard/stackRank/applyUserDrillDownListViewSettings"
)<Partial<DrillDownViewState>>();

export type StackRankActions = ActionType<
  | typeof applyUserDrillDownListViewSettings
  | typeof exportDrillDownData
  | typeof fetchDrillDownData
  | typeof fetchMetrics
  | typeof fetchUserDrillDownData
  | typeof hideStackRankDrillDown
  | typeof hideUserDrillDown
  | typeof initializeStackRank
  | typeof showStackRankDrillDown
  | typeof showUserDrillDown
  | typeof updateDrillDownViewState
  | typeof updateStackRankViewState
>;
